import { PATH_MESSAGE, PATH_REPORT360, PATH_FRAME360 } from "@/constants/URL";
import routerWithSidebar from "./routerWithSidebar";
export default [
  {
    path: PATH_MESSAGE,
    components: routerWithSidebar(() =>
      import(/* webpackChunkName: "role" */ "@/views/messagelist/index.vue")
    )
  },
  {
    path: PATH_REPORT360,
    components: routerWithSidebar(() =>
      import(/* webpackChunkName: "role" */ "@/views/report360/index.vue")
    )
  },
  {
    path: PATH_FRAME360,
    components: routerWithSidebar(() =>
      import(/* webpackChunkName: "role" */ "@/views/frame360/index.vue")
    )
  }
];
